import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyImage from 'src/utils/lazyImage';

const Avatar = ({ name, size, src }) => {
  const classes = classNames({
    'avatar': true,
    [`avatar--${size}`]: !!size,
  });

  return (
    <LazyImage
      alt={`${name} profile image`}
      classnames={classes}
      src={src}
    />
  );
};

Avatar.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']).isRequired,
  name: PropTypes.string,
  src: PropTypes.string,
};

Avatar.defaultProps = {
  name: '',
  src: '',
};

export default Avatar;
